function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M182.127 317.327C181.213 331.057 172.837 342.291 163.514 342.291H49.3465C40.0233 342.291 31.6473 331.057 30.7339 317.327L12.722 46.6725C11.8086 32.9436 18.6899 21.7094 28.013 21.7094H184.848C194.171 21.7094 201.053 32.9425 200.139 46.6725L182.127 317.327Z",
  fill: "#505050"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M107 78V324H184L198 78H107Z",
  fill: "#404040"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M193.916 21.7103C204.379 21.7103 212.861 34.2613 212.861 49.7422C212.861 65.2241 204.378 77.7741 193.916 77.7741H18.9446C8.48228 77.7752 0 65.2252 0 49.7422C0 34.2613 8.48228 21.7103 18.9446 21.7103H193.916Z",
  fill: "#505050"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M202.547 22C208.32 22 213 34.5367 213 50C213 65.4643 208.32 78 202.547 78H106C106 59.9567 106 50.4676 106 50.4676C106 35.0043 106 38.9806 106 22H202.547Z",
  fill: "#4B4B4B"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  d: "M57.2644 181.57H107.02H57.2644Z",
  stroke: "white",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M105.438 181.966L99.5026 244.574H70.1832L58.8274 181.966",
  stroke: "white",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M92.1431 244.574L94.3589 181.57H82.4492L84.4671 244.574H78.0968L70.302 181.57M60.9246 193.061H104.251L103.459 203.364H62.7051L64.5648 213.666H102.351L101.481 223.969H66.5035L68.3236 234.271H100.294L60.9246 193.061Z",
  stroke: "white",
  strokeWidth: 3.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M77.8594 140.954L141.048 141.113C146.588 147.294 155.688 168.097 156.084 173.249L124.43 174.834C123.639 164.135 118.891 154.585 118.099 153.08L77.8594 140.954ZM124.43 176.815L113.747 246.159L138.279 200.59L149.357 246.555L155.688 177.607L124.43 176.815Z",
  fill: "white"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M128.387 139.567C134.942 139.567 140.257 134.245 140.257 127.68C140.257 121.115 134.942 115.792 128.387 115.792C121.831 115.792 116.516 121.115 116.516 127.68C116.516 134.245 121.831 139.567 128.387 139.567Z",
  fill: "white"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M65.7122 170.079C76.5536 164.531 76.4745 156.21 77.3449 156.21C87.6324 160.569 97.5242 161.757 103.855 160.172C85.4167 174.437 94.7545 174.834 92.2222 174.041C84.4275 171.267 73.1112 179.589 65.7122 170.079ZM85.0605 158.984C95.1502 158.984 95.1502 155.814 97.1286 154.902C97.1286 154.902 98.3156 158.984 100.69 160.965",
  fill: "white"
});

var _ref12 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip0"
}, React.createElement("rect", {
  width: 213,
  height: 364,
  fill: "white"
})));

var SvgWasteBinTidyman = function SvgWasteBinTidyman(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 213,
    height: 364,
    viewBox: "0 0 213 364",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("g", {
    clipPath: ""
  }, _ref2, _ref3, _ref4, _ref5, React.createElement("g", {
    opacity: 0.6
  }, React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11))), _ref12);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgWasteBinTidyman, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waste-bin-tidyman.fbc12736.svg";
export { ForwardRef as ReactComponent };